<template>
  <div class="memberIndex">
    <OrderMaterialList :orderId="orderId" :isDialogShow.sync="isDialogShow" />
    <div class="right">
      <div class="currentMenu"></div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">PO单</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>PO单编号</span>
            <el-input type="text" class="input" v-model="Query.OrderNumber" size="mini"></el-input>
            <span>下单日期</span>
            <el-date-picker
              v-model="Query.CreateDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              style="margin-right: 50px; margin-left: 5px"
            >
            </el-date-picker>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane name="first">
              <span slot="label">待签署({{ ComfirmList.length }})</span>
              <el-table class="table_wrap1" :data="ComfirmList" style="width: 100%" :fit="true">
                <el-table-column prop="OrderNumber" label="PO单编号">
                  <template slot-scope="scope">
                    <el-link @click="fnGoDetail(scope.row.OrderId)" target="_blank"> {{ scope.row.OrderNumber }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="CompanyName" label="成本公司" width="250px"></el-table-column>
                <el-table-column prop="CreateDate" label="下单日期"></el-table-column>
                <el-table-column prop="SumFee" label="订单金额" width="300px"></el-table-column>
                <el-table-column prop="CurrentStepEnum" label="状态"></el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div class="btn_wrap">
                      <el-button type="text" class="btn" size="small" @click="fnComfirm(scope.row.OrderId)" v-if="scope.row.CurrentStep == 1"> 确认订单</el-button>
                      <el-button type="text" class="btn" size="small" @click="fnCaSeal(scope.row.OrderId, scope.row.OrderNumber, scope.row.FileId)" v-if="scope.row.CurrentStep == 3">
                        盖章确认</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane name="second">
              <span slot="label">验收中({{ AcceptanceList.length }})</span>
              <div class="save_wrap">
                <el-button type="primary" class="submit_btn1" @click="fnOrderInvoice()">发货登记</el-button>
              </div>
              <el-table class="table_wrap1" :data="AcceptanceList" style="width: 100%" :fit="true" @selection-change="handleSelectionChange1">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="OrderNumber" label="PO单编号">
                  <template slot-scope="scope">
                    <el-link @click="fnGoDetail(scope.row.OrderId)" target="_blank"> {{ scope.row.OrderNumber }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="CompanyName" label="成本公司" width="250px"></el-table-column>
                <el-table-column prop="CreateDate" label="下单日期"></el-table-column>
                <el-table-column prop="SumFee" label="订单金额" width="300px"></el-table-column>
                <el-table-column prop="CurrentStepEnum" label="验收状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.AcceptanceCount == 0">--</span>
                    <span v-if="scope.row.AcceptanceCount > 0"> {{ scope.row.AcceptanceCount }}/{{ scope.row.MaterialCount }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div class="btn_wrap">
                      <el-button type="text" class="btn" size="small" @click="fnOpenMaterialList(scope.row.OrderId)"> 查看验收进度</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane name="third">
              <span slot="label">待对账({{ ReconciliationList.length }})</span>
              <div class="save_wrap">
                <el-button type="primary" class="submit_btn1" @click="fnReconciliation()">创建对账单</el-button>
              </div>
              <el-table class="table_wrap1" :data="ReconciliationList" style="width: 100%" :fit="true" @selection-change="handleSelectionChange2">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="OrderNumber" label="PO单编号" width="200px">
                  <template slot-scope="scope">
                    <el-link @click="fnGoDetail(scope.row.OrderId)" target="_blank"> {{ scope.row.OrderNumber }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="MaterialCode" label="物品代码"></el-table-column>
                <el-table-column prop="MaterialName" label="物品名称"></el-table-column>
                <el-table-column prop="Specification" label="型号规格"></el-table-column>
                <el-table-column prop="MaterialCount" label="采购数" width="100px"></el-table-column>
                <el-table-column prop="InvoiceCount" label="到货数" width="100px"></el-table-column>
                <el-table-column prop="CancelCount" label="取消数" width="100px"></el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane name="fourth">
              <span slot="label">已对账({{ IsReconciliationList.length }})</span>

              <el-table class="table_wrap1" :data="IsReconciliationList" style="width: 100%" :fit="true">
                <el-table-column prop="OrderNumber" label="PO单编号" width="200px">
                  <template slot-scope="scope">
                    <el-link @click="fnGoDetail(scope.row.OrderId)" target="_blank"> {{ scope.row.OrderNumber }}</el-link>
                  </template>
                </el-table-column>

                <el-table-column prop="MaterialCode" label="物品代码"></el-table-column>
                <el-table-column prop="MaterialName" label="物品名称"></el-table-column>
                <el-table-column prop="Specification" label="型号规格"></el-table-column>
                <el-table-column prop="MaterialCount" label="采购数" width="100px"></el-table-column>
                <el-table-column prop="InvoiceCount" label="对账数" width="100px"></el-table-column>
                <el-table-column prop="ReconciliationDate" label="对账日期"></el-table-column>
                <el-table-column prop="ReconciliationTitle" label="关联月度对账单"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderMaterialList from '@/views/Order/OrderMaterialList.vue'
export default {
  components: {
    OrderMaterialList
  },
  data() {
    return {
      selected: [],
      Query: {
        OrderNumber: '',
        CreateDate: ''
      },
      ComfirmList: [],
      AcceptanceList: [],
      ReconciliationList: [],
      IsReconciliationList: [],
      activeName: 'first',
      orderId: '',
      isDialogShow: false,
      selectAcceptanceList: [],
      selectReconciliationList: []
    }
  },
  mounted() {
    this.fnGetData()
    window.addEventListener('storage', (e) => {
      let that = this
      if (e.key == 'orderList') {
        localStorage.removeItem('orderList')
        this.fnGetData()
      }
    })
  },
  methods: {
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/Order/GetOrderList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.ComfirmList = res.data.ComfirmList
            this.AcceptanceList = res.data.AcceptanceList
            this.ReconciliationList = res.data.ReconciliationList
            this.IsReconciliationList = res.data.IsReconciliationList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleSelectionChange1(val) {
      this.selectAcceptanceList = val
    },
    handleSelectionChange2(val) {
      this.selectReconciliationList = val
    },
    fnComfirm(OrderId) {
      let routerData = this.$router.resolve({
        name: 'ComfirmOrder',
        query: {
          OrderId: OrderId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnCaSeal(OrderId, OrderNumber, FileId) {
      let routerData = this.$router.resolve({
        name: 'OrderCASeal',
        query: {
          OrderId: OrderId,
          OrderNumber: OrderNumber,
          FileId: FileId,
          type: 'Order'
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnOpenMaterialList(orderId) {
      this.isDialogShow = true
      this.orderId = orderId
    },
    fnOrderInvoice() {
      if (this.selectAcceptanceList.length <= 0) {
        this.$message({
          type: 'warning',
          message: '请先选择要发货登记的订单！'
        })
        return
      }
      let ids = ''
      for (let i = 0; i < this.selectAcceptanceList.length; i++) {
        ids = ids + this.selectAcceptanceList[i]['OrderId'] + ','
      }
      let routerData = this.$router.resolve({
        path: '/OrderInvoice',
        query: {
          orderId: ids
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnReconciliation() {
      if (this.selectReconciliationList.length <= 0) {
        this.$message({
          type: 'warning',
          message: '请先选择要创建对账单的物资！'
        })
        return
      }
      let ids = ''
      for (let i = 0; i < this.selectReconciliationList.length; i++) {
        ids = ids + this.selectReconciliationList[i]['AutoId'] + ','
      }
      let routerData = this.$router.resolve({
        path: '/Reconciliation',
        query: {
          orderId: ids,
          reconciliationId: ''
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnGoDetail(orderId) {
      let routerData = this.$router.resolve({
        name: 'OrderDetail',
        query: {
          orderId: orderId
        }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.save_wrap {
  padding: 5px 11px;
  text-align: right;
}
</style>